export const BUSINESS_UNIT = { 
    Nuevo: '0km',
    Usado: 'Usados',
    PlanAhorro: 'Planes de ahorro'
}

export const BUSINESS_UNIT_TABS = [
    { label: BUSINESS_UNIT.Nuevo, index: 1, tabClassName: 'short-tab' },
    { label: BUSINESS_UNIT.Usado, index: 2, tabClassName: 'short-tab' },
    { label: BUSINESS_UNIT.PlanAhorro, index: 3, tabClassName: 'long-tab' }
]

export const VISTA_FILA = '#fila'

export const DEFAULT_PER_PAGE = 12

export const PER_PAGE_OPTIONS = [
    { value: 12, label: 12 },
    { value: 24, label: 24 },
    { value: 36, label: 36 },
]

export const BASE_SORT_LIST_OPTIONS = [ 
  { name: 'Menor precio', value: 'precio_local'}, 
  { name: 'Mayor precio', value: '-precio_local'}
]
  
export const USED_SORT_LIST_OPTIONS = [
  ...BASE_SORT_LIST_OPTIONS, 
  { name: 'Menor kilometraje', value: 'KM'},
  { name: 'Mayor kilometraje', value: '-KM'},
  { name: 'Menor antigüedad', value: '-AÑO'},
  { name: 'Mayor antigüedad', value: 'AÑO'}
]
  
export const NEW_SORT_LIST_OPTIONS = [
  ...BASE_SORT_LIST_OPTIONS
]
  
export const PLAN_SORT_LIST_OPTIONS = [
  { name: 'Menor cuota', value: 'instalment_amount'},
  { name: 'Mayor cuota', value: '-instalment_amount'},
]

export const LIST_OPTIONS ={
  1: NEW_SORT_LIST_OPTIONS,
  2: USED_SORT_LIST_OPTIONS,
  3: PLAN_SORT_LIST_OPTIONS
}

export const TAB_SELECTED ={
  ZERO_KM: 0,
  USED_CAR: 1,
  SAVINGS_PLAN:2,
}

export const YOUTUBE_TYPE = 'video/youtube'
